module.exports = "0.37.0";



// WEBPACK FOOTER //
// ./node_modules/autocomplete.js/version.js